var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function handleResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!response.ok) {
            let errorMessage = response.statusText || '';
            if (!errorMessage) {
                try {
                    // Only use response.text if statusText is empty
                    const text = yield response.text();
                    if (text) {
                        errorMessage = text;
                    }
                }
                catch (_a) {
                    // Ignore parsing errors
                }
            }
            const error = { status: response.status, statusText: errorMessage };
            return Promise.reject(error);
        }
        try {
            if (response.status === 204) {
                return Promise.resolve();
            }
            return response.json().then((json) => json);
        }
        catch (_b) {
            return Promise.resolve();
        }
    });
}
export function fetchWrapper(path, options) {
    const { method, headers, query, signal } = options;
    const reqOptions = { method, headers };
    if (signal) {
        reqOptions.signal = signal;
    }
    if (method === 'POST' || method === 'PATCH') {
        const { body } = options;
        if (typeof body === 'object') {
            reqOptions.body = JSON.stringify(body);
            reqOptions.headers = Object.assign(Object.assign({}, reqOptions.headers), { 'Content-Type': 'application/json' });
        }
    }
    const queryParams = query ? new URLSearchParams(query).toString() : '';
    return fetch(`${path}${queryParams ? `?${queryParams}` : ''}`, reqOptions).then((response) => handleResponse(response));
}
//# sourceMappingURL=fetchWrapper.js.map